import { type Common } from '../common.js';
import {
  type Document,
  type DocumentItem,
  type DocumentText,
  type FilterOptions,
} from '../models/patient/document.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async get(documentId: string): Promise<Document> {
    const url = this.common.constructPath(`/patient-documents/${documentId}`);
    return await this.common.getJSON(url);
  }

  async findAll(options: { patientOrderId: string }): Promise<Document[]> {
    const url = this.common.constructPath(`/patient-documents`, options);
    return await this.common.getJSON(url);
  }

  downloadDocument(documentId: string): string {
    return this.common.constructPath(`/patient-documents/${documentId}/file`);
  }

  async getText(documentId: string): Promise<DocumentText> {
    const url = this.common.constructPath(`/patient-documents/${documentId}/text`);
    return await this.common.getJSON(url);
  }

  async getDocuments(options: FilterOptions): Promise<DocumentItem[]> {
    const url = this.common.constructPath(`/patient-documents/filter`, options);
    return await this.common.getJSON(url);
  }
}
